<script setup>
/* eslint-disable */
import { computed, ref } from 'vue'
import { useRouter } from 'vue-router';
import { useMarketsStore } from '@/stores/markets';
import { useLiveSportsStore } from '@/stores/live_sports';
import { useFixtureStore } from '@/stores/fixture';
import { useFavouritesStore } from '@/stores/favourites';

import LiveFixtureDoubleMarketOverviewOdd from '@/components/esports/highlights/LiveFixtureDoubleMarketOverviewOdd.vue';
import LiveFixtureDoubleSecondMarketOverviewOdd from '@/components/esports/highlights/LiveFixtureDoubleSecondMarketOverviewOdd.vue';

import { useBestlineVideoStore } from '@/stores/bestline_video';
import { useVirtualCourtStore } from '@/stores/virtual_court';
import LiveIcon from '@/components/Common/LiveIcon.vue';

const router = useRouter();
const marketsStore = useMarketsStore();
const liveSportsStore = useLiveSportsStore();
const fixtureStore = useFixtureStore();
const favouritesStore = useFavouritesStore();

const bestlineVideoStore = useBestlineVideoStore();
const virtualCourtStore = useVirtualCourtStore();
import commonSvgs from '@/assets/svgs/commonSvgs.json'
const svg_data = ref(commonSvgs);

const props = defineProps({
	primary_overview_market: {
		required: true,
	},
	secondary_overview_market: {
		required: true,
	},
	fixture: {
		type: Object,
		required: true,
	}
});

const is_hidden = ref(false);

const visibilityChanged = (isVisible, entry) => {
	is_hidden.value = !isVisible;
}

const toggleFavourite = () => {
	favouritesStore.toggleFixture(props.fixture.id);
}

const goToFixture = () => {
	router.push({ name: 'live-Esports-eventview', params: { fixture_id: props.fixture.id } })
}

const hasVideo = computed(() => {

	if (bestlineVideoStore.hasVideo(props.fixture)) return true;
	return false;
});

const selectVirtualLiveFixture = () => {
	virtualCourtStore.setFixtureInQueue(props.fixture);
}

const showVideoOrVirtualLive = computed(() => {
	let has_video = false;

	let video_events = bestlineVideoStore.videoEvents;
	has_video = bestlineVideoStore.hasVideo(props.fixture);



	// if (props.fixture && props.fixture.external_id && Array.isArray(video_events) && video_events.length > 0) {
	// 	has_video = video_events.some(event => event.id === props.fixture.external_id);
	// }

	let has_vl = liveSportsStore.hasVirtualLive(props.fixture.sport_id);

	if (has_video && has_vl) return 'video';
	else if (has_video) return 'video';
	else if (has_vl) return 'vl';

	return null;
});

const primaryOverviewMarketOdds = computed(() => {
	if (!props.fixture.overview_markets.hasOwnProperty(props.primary_overview_market.slug)) return [];

	return props.fixture.overview_markets[props.primary_overview_market.slug];
});

const secondaryOverviewMarketOdds = computed(() => {
	if (!props.fixture.overview_markets.hasOwnProperty(props.secondary_overview_market.slug)) return [];

	return props.fixture.overview_markets[props.secondary_overview_market.slug];
});

</script>

<template>
	<div class="live-info-inner esports_inner-main esports_inner-live" v-observe-visibility="visibilityChanged" :style="is_hidden ? 'visibility:hidden;' : ''">
		<!-- live team info start -->
		<div class="live-teams">
			<div class="star-ico" @click="toggleFavourite">
				<svg xmlns="http://www.w3.org/2000/svg" width="12" height="11.143" viewBox="0 0 12 11.143">
					<path :style="{ fill: fixture.favourite ? '#63A246' : '' }" id="Icon_ionic-ios-star" :class="`fixture-${fixture?.id}`" data-name="Icon ionic-ios-star" d="M12.67,5.545H8.729l-1.2-3.573a.434.434,0,0,0-.814,0l-1.2,3.573H1.554a.43.43,0,0,0-.429.429.315.315,0,0,0,.008.072.412.412,0,0,0,.179.3L4.551,8.63,3.308,12.244a.43.43,0,0,0,.147.482.414.414,0,0,0,.241.1.525.525,0,0,0,.268-.1l3.161-2.253,3.161,2.253a.5.5,0,0,0,.268.1.385.385,0,0,0,.238-.1.425.425,0,0,0,.147-.482L9.7,8.63l3.212-2.3.078-.067a.449.449,0,0,0,.139-.287A.454.454,0,0,0,12.67,5.545Z" transform="translate(-1.125 -1.688)" fill="#4e545d"></path>
				</svg>
			</div>
			<div class="info-inner">
				<div class="live-badge" v-if="fixture.live" v-html="svg_data.live_badge"></div>
				<div class="live-data-desktop" v-if="liveSportsStore.hasFixtureClock(props.fixture.sport_id)" @click="goToFixture">
					<h3>
						<dl>
							{{ fixtureStore.fixtureClockTime(props.fixture) }}
							<dt> {{ fixtureStore.fixtureState(props.fixture) }}</dt>
						</dl>

						<span></span>
					</h3>
				</div>
				<div class="live-data-desktop" v-else>
					<h3> {{ fixtureStore.fixtureState(props.fixture) }}</h3>
					<span></span>
				</div>
				<div class="virtual-live" v-if="showVideoOrVirtualLive">
					<div v-if="showVideoOrVirtualLive == 'vl'" @click="selectVirtualLiveFixture" class="vl-icon"
						:class="{ 'icon-selected': virtualCourtStore.fixture_in_queue?.virtual_live_id == props.fixture?.virtual_live_id }">
						<svg class="event-field-svg" xmlns="http://www.w3.org/2000/svg" xml:space="preserve" version="1.1"
							style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
							viewBox="0 0 50 34" xmlns:xlink="http://www.w3.org/1999/xlink" :style="{ height: props.fixture.sport_id === 22 ? '27px' : '' }">
							<use :xlink:href="liveSportsStore.virtualLiveIcon(props.fixture.sport_id) + '#Layer_x0020_1'" />
						</svg>
					</div>
					<div v-else-if="showVideoOrVirtualLive == 'video'" @click="selectVirtualLiveFixture"
						class="field-icon-container"
						:class="{ 'video-icon-selected': virtualCourtStore.fixture_in_queue?.id == props.fixture.id }">
						<LiveIcon/>
					</div>
				</div>
			</div>

			<div class="team-name" @click="goToFixture">
				<div class="info-inner">
					<div class="live-badge" v-html="svg_data.live_badge"></div>

					<div class="live-data-mobile" v-if="liveSportsStore.hasFixtureClock(props.fixture.sport_id)">
						<h3>
							<dl>
							{{ fixtureStore.fixtureClockTime(props.fixture) }}
							<dt> {{ fixtureStore.fixtureState(props.fixture) }}</dt>
							</dl>

							<span></span>
						</h3>
					</div>
					<div class="live-data-mobile" v-else>
						<h3> {{ fixtureStore.fixtureState(props.fixture) }}</h3>
						<span></span>
					</div>
				</div>
				<div class="team-inner">
					<p>
						<span class="playing-team" v-if="props.fixture.statistics?.possession && props.fixture.statistics?.possession == 1"></span>
						{{ props.fixture.participants ? props.fixture.participants[0] : '' }}
					</p>
					<!-- <div class="live-round-score">
						<span>{{ props.fixture.statistics?.p1_score }}</span>
						<span v-if="liveSportsStore.hasThreeScores(props.fixture.sport_id)">{{ props.fixture.statistics?.p1_games }}</span>
						<span v-if="liveSportsStore.hasTwoScores(props.fixture.sport_id)">{{ props.fixture.statistics?.p1_points }}</span>
					</div> -->
				</div>
				<div class="team-inner" v-if="!liveSportsStore.hasOneParticipant(props.fixture.sport_id)">
					<p>
						<span class="playing-team" v-if="props.fixture.statistics?.possession && props.fixture.statistics?.possession == 2"></span>
						{{ props.fixture.participants ? props.fixture.participants[1] : '' }}
					</p>
					<!-- <div class="live-round-score">
						<span>{{ props.fixture.statistics?.p2_score }}</span>
						<span v-if="liveSportsStore.hasThreeScores(props.fixture.sport_id)">{{
								props.fixture.statistics?.p2_games }}</span>
						<span v-if="liveSportsStore.hasTwoScores(props.fixture.sport_id)">{{ props.fixture.statistics?.p2_points }}</span>

					</div> -->
				</div>
			</div>
		</div>
		<!-- live team info start -->
		<!-- full bet result start -->
		<div class="outer-betting-info info-left" v-if="primary_overview_market">
			<div class="esport-score-main">
				<div class="esport-scoreboard">
					<div class="main-score">
						<span class="score-box">{{ props.fixture.statistics?.p1_score ?? 0 }}</span>
						<span class="score-divider">:</span>
						<span class="score-box">{{ props.fixture.statistics?.p2_score ?? 0 }}</span>
					</div>

					<template v-if="props.fixture.sport_id == 55">
						<div class="sub-scores" v-if="(props.fixture.statistics?.p1_points != null && props.fixture.statistics?.p2_points != null) || (props.fixture.statistics?.p1_games != null && props.fixture.statistics?.p2_games != null)">
							<span class="sub-score-item" v-if="props.fixture.statistics?.p1_games != null && props.fixture.statistics?.p2_games != null">
								({{ props.fixture.statistics.p1_games }}:{{ props.fixture.statistics.p2_games }})
							</span>
							<span class="sub-score-item" v-if="props.fixture.statistics?.p1_points != null && props.fixture.statistics?.p2_points != null">
								({{ props.fixture.statistics.p1_points }}:{{ props.fixture.statistics.p2_points }})
							</span>
						</div>
					</template>
				</div>
			</div>
			<div class="betting_info">
				<div class="betting-info-esports">
					<div class="team-info"  @click="goToFixture">
						<p>
							<span class="playing-team" v-if="props.fixture.statistics?.possession && props.fixture.statistics?.possession == 1"></span>
							{{ props.fixture.participants ? props.fixture.participants[0] : '' }}
						</p>
					</div>
					<LiveFixtureDoubleMarketOverviewOdd
						:overview_market_header_name="primary_overview_market.odd_names[0]"
						:overview_odd="primaryOverviewMarketOdds[0]"
						:needs_indicator="marketsStore.overviewMarketNeedsIndicator(primary_overview_market)"
						:fixture_id="props.fixture.id"
					/>
				</div>

				<!-- <LiveFixtureDoubleMarketOverviewOdd v-if="primary_overview_market.three_way"
					:overview_market_header_name="primary_overview_market.odd_names[1]"
					:overview_odd="primaryOverviewMarketOdds[1]"
					:needs_indicator="marketsStore.overviewMarketNeedsIndicator(primary_overview_market)"
					:fixture_id="props.fixture.id"
				/> -->
				<div class="center-info">
					<p>vs</p>
				</div>

				<div class="betting-info-esports">

					<LiveFixtureDoubleMarketOverviewOdd
						:overview_market_header_name="primary_overview_market.odd_names[2]"
						:overview_odd="primary_overview_market.three_way ? primaryOverviewMarketOdds[2] : primaryOverviewMarketOdds[1]"
						:needs_indicator="marketsStore.overviewMarketNeedsIndicator(primary_overview_market)"
						:fixture_id="props.fixture.id"
					/>
					<div class="team-info"  @click="goToFixture">
						<p>
							<span class="playing-team" v-if="props.fixture.statistics?.possession && props.fixture.statistics?.possession == 1"></span>
							{{ props.fixture.participants ? props.fixture.participants[1] : '' }}
						</p>
					</div>
				</div>
			</div>
		</div>
		<!-- full bet result end -->
		<!-- match goals start -->

		<div class="outer-betting-info info-right" v-if="secondary_overview_market">

			<div class="match-score_info">
				<!-- <LiveFixtureDoubleSecondMarketOverviewOdd
					:overview_market_header_name="secondary_overview_market.odd_names[0]"
					:overview_odd="secondaryOverviewMarketOdds[0]"
					:needs_indicator="marketsStore.overviewMarketNeedsIndicator(secondary_overview_market)"
					:fixture_id="props.fixture.id"
				/>

				<LiveFixtureDoubleSecondMarketOverviewOdd v-if="secondary_overview_market.three_way"
					:overview_market_header_name="secondary_overview_market.odd_names[1]"
					:overview_odd="secondaryOverviewMarketOdds[1]"
					:needs_indicator="marketsStore.overviewMarketNeedsIndicator(secondary_overview_market)"
					:fixture_id="props.fixture.id"
				/>

				<LiveFixtureDoubleSecondMarketOverviewOdd
					:overview_market_header_name="secondary_overview_market.odd_names[2]"
					:overview_odd="secondary_overview_market.three_way ? secondaryOverviewMarketOdds[2] : secondaryOverviewMarketOdds[1]"
					:needs_indicator="marketsStore.overviewMarketNeedsIndicator(secondary_overview_market)"
					:fixture_id="props.fixture.id"
				/> -->

				<div class="total-bet" @click="goToFixture">
					<div class="total-bet-main">
						<h6>{{ fixture.odds_count }} {{$t('account.affiliate.bets')}}</h6>
					</div>
				</div>
			</div>

		</div>
			<!-- mobile-live icon start -->
			<div class="mobile-bottom-live" :class="{'has-video': hasVideo}" @click="goToFixture">
				<div class="info-inner">
						<div class="live-data-desktop" >
							<h3> {{ fixtureStore.fixtureState(props.fixture) }}</h3>
							<span></span>
						</div>
						<div class="live-badge" v-html="svg_data.live_badge"></div>

				</div>
				<div v-if="hasVideo" @click="selectVirtualLiveFixture"
					class="field-icon-container">
					<LiveIcon/>
				</div>
				<div @click="goToFixture" class="betting-total-mobile">
					<p><img src="/assets/icons/plus-bets.svg" alt="" />&nbsp;{{ props.fixture.odds_count }} {{$t('account.affiliate.bets')}}</p>
				</div>
			</div>
			<!-- mobile-live icon start -->
		<!-- match goals end -->
	</div>
</template>
<style scoped>
.live-info-inner {
	/* Force hardware acceleration */
	transform: translate3d(0, 0, 0);
	-webkit-transform: translate3d(0, 0, 0);
}

@media screen and (min-width: 768px) {
	.esports_inner-live{
		grid-template-columns: 0.3fr 1.5fr 75px !important;
	}
}

.live-bet-dashboard.round-games-main .live-tab-info .live-info-outer .live-info-inner .mobile-bottom-live.has-video {
	grid-template-columns: 22px 0.2fr 1fr auto;
}

.event-field-svg {
	height: 17px;
	fill: var(--border-light);
}

.event-field-svg:hover {
	fill: var(--white);
}

.icon-selected .event-field-svg {
	fill: var(--white);
	stroke: var(--white);
}

.live-teams .info-inner .live-data-desktop {
	width: 50px;
	flex-shrink: 0;
}

.live-teams .info-inner .live-data-desktop h3 dl {
	font-variant-numeric: tabular-nums;
	font-feature-settings: "tnum";
	white-space: nowrap;
}

.live-teams .info-inner .virtual-live {
	flex-shrink: 0;
}

.live-data-desktop {
	width: 50px !important;
}

.esport-score-main {
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 0 0 8px;
}

.esport-scoreboard {
	display: inline-flex;
	align-items: center;
	gap: 6px;
	padding: 2px 8px;
	background: rgba(255, 255, 255, 0.04);
	border: 1px solid rgba(255, 255, 255, 0.08);
	border-radius: 6px;
}

.main-score {
	display: inline-flex;
	align-items: center;
	gap: 3px;
}

.score-box {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	min-width: 22px;
	height: 20px;
	padding: 0 4px;
	background: rgba(0, 0, 0, 0.35);
	border: 1px solid var(--tab-gray);
	border-radius: 3px;
	color: var(--white);
	font-size: 12px;
	font-weight: 600;
	font-variant-numeric: tabular-nums;
	line-height: 1;
}

.score-divider {
	color: var(--primary);
	font-size: 13px;
	font-weight: 700;
	line-height: 1;
}

.sub-scores {
	display: inline-flex;
	align-items: center;
	gap: 4px;
}

.sub-score-item {
	font-size: 11px;
	font-weight: 400;
	color: var(--tab-light-gray);
	font-variant-numeric: tabular-nums;
}
</style>
